import { SetStateAction, useCallback, useEffect, useState } from 'react';

export default function useMetricsHook({
  filterColumns,
  metricsOptions,
}: {
  filterColumns: Array<string>;
  metricsOptions: { value: string }[];
}) {
  const [showColumns, setShowColumns] = useState<string[]>(
    metricsOptions.map((item) => item.value),
  );

  useEffect(() => {
    setShowColumns(metricsOptions.map((item) => item.value));
  }, [metricsOptions]);

  const getTotalColumns = useCallback(
    (totalColumnList: any[]) => {
      return totalColumnList.filter(
        (item) =>
          filterColumns.includes(item.key) || showColumns.includes(item.key),
      );
    },
    [showColumns],
  );

  const filterChange = (
    value: { [x: string]: SetStateAction<string[]> },
    key?: string,
  ) => {
    if (key === 'metrics') {
      setShowColumns(value[key!]);
    }
  };

  return {
    filterChange,
    getTotalColumns,
    showColumns,
  };
}
